import styled, { css } from 'styled-components'

export const PerfilBox = styled.div`
  ${({ theme }) => css`
    background: #ffffff;
    padding: 32px;
    border: 1px solid #e5e5e5;
    border-radius: 4px;
    box-shadow: 0px 0px 4px rgba(0, 0, 0, 0.1);
    margin-bottom: 20px;

    .description-small {
      font-size: 13px;
      margin-top: 10px;
    }

    @media (max-width: ${theme.media.ipad}) {
      padding: 24px;
    }
  `}
`

export const PerfilFormGroup = styled.div`
  ${({ theme }) => css`
    position: relative;
    font-size: 14px;

    label {
      font-size: 14px;
      font-weight: 400;
      color: #4a4a4a;
      display: block;
      margin-bottom: 8px;
    }

    small {
      display: block;
      margin-bottom: 5px;
    }

    &.required {
      label {
        &:after {
          content: '*';
          color: ${theme.colors.primary};
          display: inline-block;
          margin-left: 4px;
        }
      }
    }
  `}
`

export const PerfilTitle = styled.h3`
  font-size: 18px;
  font-weight: 500;
  color: #4a4a4a;
  margin-bottom: 18px;
`

export const PerfilInputCheck = styled.input`
  left: -9999px;
  position: absolute;
`
export const PerfilLabel = styled.label`
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  padding-left: 23px;
  position: relative;
`
